import { HttpApiError, HttpApiGroup } from "@effect/platform";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";

import { PublishNotificationResponse } from "../models/support-ticket/support-ticket-notification";
import {
  NotifyPresenceInput,
  NotifyTypingInput,
} from "../models/team/presence-notification";

export const TeamNotificationGroup = HttpApiGroup.make("team-notification")
  .add(
    endpoint.merchant
      .post("notifyTyping", "/notifications/typing")

      .setPayload(NotifyTypingInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("notifyPresence", "/notifications/presence")

      .setPayload(NotifyPresenceInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.NotFound)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
